export const isInteger = (value: string) => {
  const expRegOnlyNumers = /^-?\d+$/;
  return value.match(expRegOnlyNumers);
};
